import React, { useMemo } from 'react';
import Icon from '@mdi/react';
import { Collapse, List, ListItem, ListItemButton, ListItemText, Stack } from '@mui/material';
import { headingFontBold, vars } from '../../../../Theme';
import { mdiChevronDown, mdiChevronUp } from '@mdi/js';
import { groupBy } from 'lodash';
import AssignmentActivityLogs, { IActivityLogAssigment } from './AssignmentActivityLogs';

export default ({ data }: { data: IActivityLogAssigment[] }) => {
    const [expanded, setExpanded] = React.useState<string[]>([]);
    const groups = useMemo(() => Object.entries(groupBy(data, 'DocumentType')), [data]);

    const toggleExpanded = (group: string) => {
        setExpanded(
            expanded.filter(x => x !== group).concat(expanded.includes(group) ? [] : group),
        );
    };

    return (
        <List sx={{ p: 0, m: 0, overflowY: 'auto' }}>
            {groups.map(([group, items]) => (
                <ListItem key={group} sx={{ p: 0 }}>
                    <Stack width={'100%'}>
                        <ListItemButton sx={{ p: 1 }} onClick={() => toggleExpanded(group)}>
                            <ListItemText sx={{ color: vars.font, ...headingFontBold }}>
                                {group ?? 'test'}
                            </ListItemText>
                            <Icon
                                path={expanded.includes(group) ? mdiChevronUp : mdiChevronDown}
                                color={vars.font}
                                size={1}
                            />
                        </ListItemButton>
                        <Collapse in={expanded.includes(group)} timeout='auto' unmountOnExit>
                            <AssignmentActivityLogs data={items} />
                        </Collapse>
                    </Stack>
                </ListItem>
            ))}
        </List>
    );
};
